import {
  Rt
} from "./chunk.LTAMHVKK.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  debounce
} from "./chunk.WXNWU2SV.js";
import {
  Oe,
  h,
  ke
} from "./chunk.FCKNEYTX.js";
import {
  n
} from "./chunk.BBN2ZB42.js";
import {
  i,
  r
} from "./chunk.FAJKIEWS.js";
import {
  __decorateClass
} from "./chunk.I4IFG4JG.js";

// src/components/jb-wealth-report-list/jb-wealth-report-list.scss?inline
var jb_wealth_report_list_default = i`*,
*::before,
*::after {
  box-sizing: border-box;
}

div,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
ol,
ul,
li,
form,
legend,
label,
table,
header,
footer,
nav,
section,
figure {
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

/* COLOR SETTINGS */
/* shadows */
:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
/* stylelint-disable */
/* stylelint-enable */
button {
  font-family: var(--theme-font-black-family, VerlagSSm, Tahoma, sans-serif);
  font-weight: var(--theme-font-black-weight, 900);
}

table tbody td.highlight, table thead tr th.highlight {
  font-family: var(--theme-font-bold-family, VerlagSSm, Tahoma, sans-serif);
  font-weight: var(--theme-font-bold-weight, 700);
}

table tbody tr, table thead tr th, table {
  font-family: var(--theme-font-light-family, VerlagSSm, Tahoma, sans-serif);
  font-style: normal;
  font-weight: var(--theme-font-light-weight, 300);
}

table {
  color: rgba(var(--rgb-primary, 20, 30, 85), var(--text-opacity, var(--theme-opacity-80, 0.8)));
  font-size: 1rem;
  line-height: 1.625rem;
}

button {
  color: rgb(var(--rgb-primary, 20, 30, 85));
  font-size: 0.688rem;
  letter-spacing: 0.125rem;
  line-height: 1rem;
  text-decoration: none;
  text-transform: uppercase;
}

:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
:host {
  color: var(--host-color, #141e55);
}

:host {
  aspect-ratio: unset;
  display: block;
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex: 0 1 auto;
  flex-direction: row;
  flex-wrap: wrap;
  margin-left: auto;
  margin-right: auto;
  width: calc(100% - 2 * var(--row-small-margin, 6.68%));
}
@media (min-width: 600px) and (max-width: 959px) {
  :host {
    width: calc(100% - 2 * 8.35%);
  }
}
@media (min-width: 1437px) {
  :host {
    max-width: var(--row-max-width, 1436px);
  }
  :host:not(.filtered-list) {
    width: 100%;
  }
}
@media only screen and (min-width: 960px) and (max-width: 1436px) {
  :host {
    margin: 0 6.955%;
    max-width: calc(100% - 6.955% - 6.955%);
  }
}
@media (min-width: 960px) {
  :host {
    aspect-ratio: 1;
    margin: 0;
    width: 100%;
  }
}

button {
  background-color: transparent;
  border: 0;
  border-bottom: 1px solid currentcolor;
  color: rgb(var(--rgb-primary, 20, 30, 85));
  cursor: pointer;
  display: inline-flex;
  opacity: 0.4;
  padding: 6px 0;
  position: relative;
  text-transform: uppercase;
}
button.highlight {
  opacity: 1;
}
button:first-of-type {
  margin-right: 24px;
}

.buttons {
  margin-left: -15px;
  padding-left: 15px;
}
@media (min-width: 960px) {
  .buttons {
    margin-left: 0;
  }
}

.table-scroll {
  height: calc(100% - 37px);
  margin-left: -15px;
  overflow-y: auto;
  padding-left: 15px;
  width: calc(100% + 15px);
}
@media (min-width: 960px) {
  .table-scroll {
    margin-left: 0;
    width: 100%;
  }
}
.table-scroll::-webkit-scrollbar {
  background-color: #141e55;
  height: 5px;
  width: 5px;
}
.table-scroll::-webkit-scrollbar-track {
  background-clip: content-box;
  background-color: #f1f2f2;
}
.table-scroll::-webkit-scrollbar-thumb {
  background-color: #141e55;
  border-radius: 4px;
  width: 180px;
}
.table-scroll::-webkit-scrollbar-track-piece:start {
  background-color: transparent;
  margin-top: 40px;
}
@media (min-width: 960px) {
  .table-scroll {
    padding-right: 32px;
  }
  .table-scroll::after {
    background: white;
    content: "";
    height: 81px;
    position: absolute;
    right: 14px;
    top: 0;
    width: 18px;
    z-index: 2;
  }
}

table {
  border-collapse: collapse;
  text-align: left;
  width: 100%;
}
table * {
  color: RGBA(var(--rgb-primary, 20, 30, 85), 0.8);
}
table th,
table td {
  text-align: right;
}
table th:first-child,
table td:first-child {
  text-align: left;
}
table thead {
  border-bottom: 1px solid RGBA(var(--rgb-primary, 20, 30, 85), 0.3);
}
table thead tr th {
  background-color: #fff;
  padding: 16px 20px 7px 0;
  position: sticky;
  top: 0;
  z-index: 1;
}
table thead tr th:last-of-type {
  padding-right: 0;
}
table thead tr th:first-of-type::before {
  background-color: white;
  content: "";
  display: block;
  inset: 0 100% 0 -20px;
  position: absolute;
}
table tbody tr {
  border-bottom: 1px solid RGBA(var(--rgb-primary, 20, 30, 85), 0.3);
  cursor: pointer;
  line-height: 1.938rem;
}
table tbody tr.highlight td:first-child {
  position: relative;
}
table tbody tr.highlight td:first-child::before {
  background-color: #b0aa7e;
  border-radius: 8px;
  content: " ";
  height: 8px;
  left: -15px;
  position: absolute;
  top: 12px;
  width: 8px;
}
table tbody td {
  padding-right: 20px;
}
table tbody td:last-of-type {
  padding-right: 0;
}

.change {
  display: inline-block;
  text-align: center;
  width: 15px;
}

.arrow-container {
  align-items: center;
  display: inline-flex;
  height: 100%;
  justify-content: center;
  width: 20px;
}

.arrow {
  margin-top: -2px;
}
.arrow.down {
  transform: rotate(180deg);
}
.arrow.same {
  transform: rotate(90deg);
}`;

// src/components/jb-wealth-report-list/jb-wealth-report-list.ts
var JbWealthReportList = class extends h {
  constructor() {
    super(...arguments);
    this.sort = "alphabetical";
    this._directionArrow = Oe`<svg width="10" height="14" viewBox="0 0 10 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.63416 0.570797C4.86211 0.342844 5.23167 0.342864 5.4596 0.570797L9.28956 4.40075C9.51749 4.62869 9.51751 4.99825 9.28956 5.2262C9.06161 5.45415 8.69205 5.45413 8.46412 5.2262L5.04688 1.80896L1.62965 5.2262C1.40169 5.45415 1.03213 5.45413 0.804202 5.2262C0.576269 4.99827 0.576249 4.62871 0.804202 4.40075L4.63416 0.570797Z" fill="#141E55"/><rect x="4.42395" y="13.584" width="12.3445" height="1.23445" transform="rotate(-90 4.42395 13.584)" fill="#141E55"/></svg>`;
    this._lastScrollTop = 0;
  }
  _changeSortClicked(evt) {
    this.sort = evt.currentTarget.dataset.sort;
    this._sortList(this.sort);
    this.dispatchEvent(
      new CustomEvent("jb-tracking", {
        detail: {
          event: "ce_interaction",
          event_version: "v2",
          component_name: "report_component",
          interaction_element: "table-sort",
          interaction_type: "click",
          interaction_result: this.sort === "alphabetical" ? "alphabetical" : "ranking"
        },
        bubbles: true,
        composed: true
      })
    );
  }
  _cityChangeClicked(e) {
    this.selectedCity = e.currentTarget.dataset.cityKey;
    this._citySelectedEvent();
    this.dispatchEvent(
      new CustomEvent("jb-tracking", {
        detail: {
          event: "ce_interaction",
          event_version: "v2",
          component_name: "report_component",
          interaction_element: "table-row",
          interaction_type: "click",
          interaction_result: this.selectedCity
        },
        bubbles: true,
        composed: true
      })
    );
  }
  _citySelectedEvent() {
    const event = new CustomEvent("jb-wealth-report:city-selected", {
      detail: {
        cityKey: this.selectedCity
      },
      bubbles: true,
      composed: true
    });
    this.dispatchEvent(event);
  }
  _renderList() {
    this._sortList(this.sort);
    return this.list.map((listItem) => {
      const currentChange = listItem.rank21 - listItem.rank22;
      let direction;
      if (currentChange < 0) {
        direction = "down";
      } else if (currentChange > 0) {
        direction = "up";
      } else {
        direction = "same";
      }
      return ke`
        <tr
          data-city-key="${listItem.cityKey}"
          @click=${this._cityChangeClicked}
          class=${Rt({ highlight: listItem.cityKey === this.selectedCity })}
        >
          <td class=${Rt({ highlight: listItem.cityKey === this.selectedCity })}>${listItem.city}</td>
          <td class="highlight">${listItem.rank22}</td>
          <td>${listItem.rank21}</td>
          <td>
            <span class="change">${Math.abs(currentChange)}</span>
            <span class="arrow-container">
              <span class="arrow ${direction}">${this._directionArrow}</span>
            </span>
          </td>
        </tr>
      `;
    });
  }
  _scrollEvent(listScrollTop) {
    this.dispatchEvent(
      new CustomEvent("jb-tracking", {
        detail: {
          event: "ce_interaction",
          event_version: "v2",
          component_name: "report_component",
          interaction_element: "table",
          interaction_type: "scroll",
          interaction_result: listScrollTop > this._lastScrollTop ? "down" : "up"
        },
        bubbles: true,
        composed: true
      })
    );
    this._lastScrollTop = listScrollTop <= 0 ? 0 : listScrollTop;
  }
  _sortList(direction) {
    if (direction === "alphabetical") {
      this.list.sort((a, b) => {
        if (a.city < b.city) return -1;
        if (a.city > b.city) return 1;
        return 0;
      });
    } else {
      this.list.sort((a, b) => a.rank22 - b.rank22);
    }
  }
  render() {
    return ke`
      <div class="buttons">
        <button
          @click=${this._changeSortClicked}
          class=${Rt({ highlight: this.sort === "alphabetical" })}
          data-sort="alphabetical"
        >
          ${this.alphabetical}
        </button>
        <button
          @click=${this._changeSortClicked}
          class=${Rt({ highlight: this.sort === "globalranking" })}
          data-sort="globalranking"
        >
          ${this.globalRanking}
        </button>
      </div>
      <div
        class="table-scroll"
        @scroll=${debounce(() => {
      this._scrollEvent(this.renderRoot.querySelector(".table-scroll").scrollTop);
    }, 100)}
      >
        <table>
          <thead>
            <tr>
              <th></th>
              <th class="highlight">2022</th>
              <th>2021</th>
              <th>${this.change}</th>
            </tr>
          </thead>
          <tbody>
            ${this._renderList()}
          </tbody>
        </table>
      </div>
    `;
  }
};
JbWealthReportList.styles = r(jb_wealth_report_list_default);
__decorateClass([
  n()
], JbWealthReportList.prototype, "alphabetical", 2);
__decorateClass([
  n()
], JbWealthReportList.prototype, "change", 2);
__decorateClass([
  n()
], JbWealthReportList.prototype, "globalRanking", 2);
__decorateClass([
  n({ type: Array })
], JbWealthReportList.prototype, "list", 2);
__decorateClass([
  n()
], JbWealthReportList.prototype, "selectedCity", 2);
__decorateClass([
  n()
], JbWealthReportList.prototype, "sort", 2);
JbWealthReportList = __decorateClass([
  customElement("jb-wealth-report-list")
], JbWealthReportList);

export {
  JbWealthReportList
};
